<template></template>
<script>
import CTALink from '../blocks/modules/elements/CTALink';
export default {
    name        :   'BlockCommons',
    props       :   ['block'],
    components  :   { CTALink }
}
</script>



// WEBPACK FOOTER //
// src/components/mixins/BlockCommons.vue